<template>
  <div class="navbar">
    <div class="navbar__left">
      <div>
        <div class="fund-opts-dd">
          <img class="company-logo" src="@/assets/images/logo-dark.svg" />
        </div>
        <div style="margin:0 15px 0 5px;">
          <DropDownSearch
            v-model="selectedFund"
            :itemsRef.sync="selectedFundRef"
            :items="funds.list"
            valueKey="id"
            displayKey="fundTitle"
            showTriggerIcon
          />
        </div>
      </div>
    </div>
    <div class="navbar__center navbar--mb-hide">
      <router-link class="router-link" :to="{ name: 'DashboardPage' }">+Dashboard</router-link>
      <router-link class="router-link" :to="{ name: 'PostsPage' }">+Communications</router-link>
      <router-link class="router-link" :to="{ name: 'CompaniesPage' }">+Portfolio</router-link>
    </div>
    <div class="navbar__right">
      <DropDownMenu @selectedItem="onSelectedMenuItem" :items="profileMenuItems" :right="10">
        <template v-slot:dropdown-trigger="data">
          <img class="profile-icon" src="@/assets/images/profile_icon.png" />
        </template>

        <template #dd-item-dashboard="{data,classes,selectItem}">
          <div @click="selectItem(data.value)" :class="classes" class="navbar--mb-show">
            {{ data.key }}
          </div>
        </template>
        <template #dd-item-posts="{data,classes,selectItem}">
          <div @click="selectItem(data.value)" :class="classes" class="navbar--mb-show">
            {{ data.key }}
          </div>
        </template>
        <template #dd-item-companies="{data,classes,selectItem}">
          <div @click="selectItem(data.value)" :class="classes" class="navbar--mb-show">
            {{ data.key }}
          </div>
        </template>
      </DropDownMenu>
    </div>
  </div>
</template>

<script>
import { CollectionManager } from '@thinknimble/tn-models'

import Fund from '@/services/fund'
import User from '@/services/users'

import { DropDownMenu, DropDownSearch } from '@/components/'

export default {
  name: 'TopNav',
  components: { DropDownMenu, DropDownSearch },
  data() {
    return {
      profileMenuItems: [
        { value: 'dashboard', key: 'Dashboard' },
        { value: 'posts', key: 'Posts' },
        { value: 'companies', key: 'Companies' },
        { value: 'profile', key: 'Profile' },
        { value: 'contact', key: 'Contact' },
        { value: 'logout', key: 'Sign Out' },
      ],

      funds: CollectionManager.create({ ModelClass: Fund }),
      selectedFund: null,
      selectedFundRef: null,
    }
  },
  created() {
    this.selectedFund = this.storedFund
    this.selectedFundRef = this.storedFundRef
  },
  methods: {
    onSelectedMenuItem(val) {
      console.log('val', val)
      switch (val) {
        case 'profile':
          this.$router.push({ name: 'ProfilePage' })
          break
        case 'logout':
          User.api.logout()
          this.$router.push({ name: 'LoginPage' })
          break
        case 'contact':
          window.open(`mailto:${this.contactPoint}`, '_blank')
          break
        case 'dashboard':
          this.$router.push({ name: 'DashboardPage' })
          break
        case 'companies':
          this.$router.push({ name: 'CompaniesPage' })
          break
        case 'posts':
          this.$router.push({ name: 'PostsPage' })
          break
        default:
          return
      }
    },
  },
  watch: {
    isLoggedIn: {
      immediate: true,
      async handler(val) {
        if (val) {
          try {
            await this.funds.refresh()
          } catch (e) {
            console.log(e)
          }
          if (this.funds.list.length) {
            if (!this.selectedFund) {
              this.selectedFund = this.funds.list[0].id
              this.selectedFundRef = this.funds.list[0]
              this.$store.commit('SELECT_FUND', this.funds.list[0].id)
              this.$store.commit('SELECT_FUND_REF', this.funds.list[0])
            }
          }
        } else {
          this.funds = CollectionManager.create({ ModelClass: Fund })
        }
      },
    },
    selectedFund() {
      this.$store.commit('SELECT_FUND', this.selectedFund)
      this.$store.commit('SELECT_FUND_REF', this.selectedFundRef)
    },
  },
  computed: {
    contactPoint() {
      return process.env.VUE_APP_CONTACT_POINT
        ? process.env.VUE_APP_CONTACT_POINT
        : 'LPportal@constructcap.com'
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    storedFund() {
      return this.$store.getters.selectedFund
    },
    storedFundRef() {
      return this.$store.getters.selectedFundRef
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/fontstyles';

.company-logo {
  @include logo-font();
  padding: 0.5rem 1rem;
  margin: 0.2rem 0rem;
}
.navbar {
  padding: 1rem 2rem;
  display: flex;
  box-shadow: 0px 4px 4px $nav-border;
  align-items: center;
  margin-bottom: 2rem;
  &__center,
  &__left,
  &__right {
    padding: 0rem 1rem;
  }
  &__center {
    flex: 1 0 auto;
  }
  &__left {
    @include breakpoint(768px, 'max') {
      width: 10rem;
    }
  }
  @include breakpoint(768px, 'max') {
    padding: 0 0;
    width: 100%;
  }
}
.router-link {
  margin: 0 1rem;
}
.router-link-exact-active.router-link-active {
  @include navbar-item-font--active();
}
.profile-icon {
  width: 2rem;
  height: 2rem;
  object-fit: cover;

  &:hover {
    cursor: pointer;
  }
}
.fund-opts-dd {
  position: relative;
  top: 10px;
  display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
    border-right: none;
  }
  border-right: 1px solid $nav-border;
}
::v-deep .tn-dropdown--medium {
  @media screen and (max-width: 768px) {
    width: 15rem;
  }
}

.fund-title {
  @include navbar-item-font();
  line-height: 28px;
  padding: 0rem 1rem;
  position: relative;
}
.navbar--mb-show {
  display: none;
  @media screen and (max-width: 768px) {
    display: inherit;
  }
}
.navbar--mb-hide {
  @media screen and (max-width: 768px) {
    display: none;
  }
}
</style>
